// Shopify sometimes renders NL pages with the EN route root, so internal links point to /en/...
// Strip the prefix on NL pages until the platform issue is fixed.
(function () {
  function stripEnPrefix(value, origin) {
    if (!value) return value;
    var url;
    try {
      url = new URL(value, origin);
    } catch (e) {
      return value;
    }
    if (url.origin !== origin || !/^\/en(\/|$)/.test(url.pathname)) return value;
    return (url.pathname.replace(/^\/en/, '') || '/') + url.search + url.hash;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { stripEnPrefix: stripEnPrefix };
    return;
  }

  if ((document.documentElement.lang || '').toLowerCase().indexOf('nl') !== 0) return;

  var origin = window.location.origin;

  // Language switcher links carry a lang attribute and must keep /en.
  function fix(el, attr) {
    if (el.hasAttribute('lang')) return;
    var value = el.getAttribute(attr);
    var fixed = stripEnPrefix(value, origin);
    if (fixed !== value) el.setAttribute(attr, fixed);
  }

  function fixAll() {
    document.querySelectorAll('a[href]').forEach(function (a) { fix(a, 'href'); });
    document.querySelectorAll('form[action]').forEach(function (f) { fix(f, 'action'); });
  }

  if (window.Shopify && Shopify.routes && Shopify.routes.root === '/en/') Shopify.routes.root = '/';

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixAll);
  else fixAll();

  // Links injected later (sliders, AJAX, apps) are fixed right before navigation.
  ['click', 'auxclick'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var a = event.target.closest && event.target.closest('a[href]');
      if (a) fix(a, 'href');
    }, true);
  });
  document.addEventListener('submit', function (event) {
    if (event.target.matches && event.target.matches('form[action]')) fix(event.target, 'action');
  }, true);
})();
